import React from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import StrapiForm from 'gatsby-theme-forms/src/components/form';
import FormButton from 'gatsby-theme-forms/src/components/button';
import Wrapper from './wrapper';
import Title from './title';
import Subtitle from './subtitle';

const FormBlock = ({
  backgroundColor,
  title,
  subtitle,
  thanxPage,
  thanxMessageTitle,
  thanxMessageSubTitle,
  thanxMessageFooterText,
  card,
  strapiFormForm,
  className,
}) => {
  const useTheWhiteColor = backgroundColor === 'standout' && !card;
  // we need this wrapper div, because we are setting a class with styles about Container on it
  return (
    <div className={className}>
      <Container small>
        <Wrapper $card={card}>
          {title && (
            <Title $useTheWhiteColor={useTheWhiteColor}>
              {title}
            </Title>
          )}
          {subtitle && (
            <Subtitle $useTheWhiteColor={useTheWhiteColor}>
              {subtitle}
            </Subtitle>
          )}
          {strapiFormForm && (
            <StrapiForm
              {...strapiFormForm}
              $fromPdVBlocks
              horizontal={strapiFormForm.components.length === 1}
              // if there is a thanxPage, override the form redirectAfterSuccess
              {...(thanxPage ? { redirectAfterSuccess: thanxPage } : {})}
              successProps={{
                thanxMessageTitle,
                thanxMessageSubTitle,
                thanxMessageFooterText,
              }}
            />
          )}
        </Wrapper>
      </Container>
    </div>
  );
};

export default styled(FormBlock)`
  ${FormButton} {
    background-color: ${({ theme }) => theme.grayDarkColor} !important;
    border-color: ${({ theme }) => theme.grayDarkColor} !important;
    min-width: 10rem;
    width: 100%;
    border-radius: 2rem;
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      width: auto;
    }

    &:hover {
      background-color: black !important;
      border-color: black !important;
    }
  }
`;
